
import React from "react";
import {Dropdown} from "react-bootstrap";
import {Footnote} from "./FormScreenStyles";
import { useTranslation } from 'react-i18next';
import './style.css';

const fontStyle = {
    fontFamily: 'Arial',
    fontSize: 14,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineWeight: 'normal',
    letterSpacing: 'normal',
    color: '#78848f',
    // width: 220,
    height: 44,
    border: 'solid 2px #ecf0f1',
}

const FormDropdown = (props: any) => {
    const { t, i18n } = useTranslation();
    return (
        <Dropdown style={{ padding: 0, margin: 0, height: '100%', width: '100%' }}>
            <Dropdown.Toggle id="dropdown-custom-1"
                style={{
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'row',
                    border: 'solid 2px #ecf0f1',
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#FFFFFF',
                    alignItems: 'center',
                    textAlign: 'center',
                    ...props.menuStyle,
                }}
            >
                <Footnote style={{flex:1, textAlign: 'left', ...props.textStyle }}>
                    {props.currentSelection || props.placeholder || 'N/A'}
                </Footnote>
            </Dropdown.Toggle>
            {props.options && props.options.length > 0 &&
                <Dropdown.Menu style={{ backgroundColor: 'white', ...props.menuStyle, maxHeight: 220, overflowX: 'hidden', height: 'auto'}}>
                    {props.options.map((option: any, idx: number) =>
                            <Dropdown.Item
                                key={`dropdown-${option}`}
                                onClick={() => props.onClick(option)}
                                eventKey={`${idx}`}
                                style={{...props.textStyle }}
                                onSelect={(value: any) => console.log('value', value)}
                                // active={option === props.currentSelection}
                            >
                                {/* Need to remove periods from translation key, due to . being used as namespace accessor */}
                                {i18n.language !== 'en' && t(`${option.replace('.', '')}`) || option}
                            </Dropdown.Item>
                    )}
                </Dropdown.Menu>
            }
        </Dropdown>
    );
}

export default FormDropdown;